import baseRequest from "../_core/baseRequest";

/** URLSearchParams boşlukları '+' yapar; bazı backend'ler query'de %20 bekler. */
const serializeParams = params => {
    const parts = [];
    Object.keys(params || {}).forEach(key => {
        const value = params[key];
        if (Array.isArray(value)) {
            value.forEach(item => {
                if (item !== undefined && item !== null && item !== "") {
                    parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(item))}`);
                }
            });
        } else if (value !== undefined && value !== null && value !== "") {
            parts.push(`${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`);
        }
    });
    return parts.join("&");
};

export default {
    courierWithdrawRequestList: params => {
        const queryString = serializeParams(params);
        const path = `/courier-withdraw-request/list${queryString ? `?${queryString}` : ""}`;
        const isExcel = params && params.excel === true;
        return baseRequest.get(path, isExcel ? {responseType: "blob"} : undefined, isExcel);
    },
    makePaymentRequest: params => {
        return baseRequest.post(`/courier-withdraw-request/approve`, params);
    },
    cancelPaymentRequest: params => {
        return baseRequest.post(`/courier-withdraw-request/cancel`, params);
    },
    statusNames: params => {
        return baseRequest.get(`/courier-withdraw-request/status-names`, params);
    },
    addExpenseVoucher: formData => {
        return baseRequest.post(`/courier-withdraw-request/add-expense-voucher`, formData);
    },
    netsisInvoices: ({courierWithdrawRequestId}) => {
        return baseRequest.get(
            `/courier-withdraw-request/${courierWithdrawRequestId}/netsis-invoices`
        );
    }
};
